exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_3dGFC {\n    padding: 50px 80px 0px;\n}\n\n.infoContainer_3dGFC > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.conditionsContainer_HhOWE {\n    padding-top: 5px;\n}\n\n.gapSection20_jpgYK {\n    height: 500px;\n}\n\n.signatureSize_hq8x8 img {\n    max-width: 200px;\n    max-height: 80px;\n}\n\n.centerText_269i_ {\n    text-align: center;\n}\n\n.descriptionText_1ks86 {\n    font-size: 15px !important;\n}\n\n.tableSize_3p-2Q {\n    width: 100%;\n}\n\n.tableSize_3p-2Q td {\n    border: none !important;\n}\n\n.cellWidth_eGmCT {\n    width: 60%;\n}\n\n.textBorder_KnZ2G {\n    border: solid 1px;\n}\n\n.textContainer_285Zd {\n    padding: 10px 0px 100px;\n}\n\n.signatureBox_2qtm0 {\n    width: 50%;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_3dGFC",
	"conditionsContainer": "conditionsContainer_HhOWE",
	"gapSection20": "gapSection20_jpgYK",
	"signatureSize": "signatureSize_hq8x8",
	"centerText": "centerText_269i_",
	"descriptionText": "descriptionText_1ks86",
	"tableSize": "tableSize_3p-2Q",
	"cellWidth": "cellWidth_eGmCT",
	"textBorder": "textBorder_KnZ2G",
	"textContainer": "textContainer_285Zd",
	"signatureBox": "signatureBox_2qtm0"
};